"use strict";
import ApiService from "@/core/services/api.service";

const baseURL = "VisitForms";

export default {
  getAllVisitForms() {
    return new Promise(resolve => {
      ApiService.get(`${baseURL}/GetAllVisitForms`).then(({ data }) => {
        resolve(data);
      });
    });
  },
  saveVisitForm(payload) {
    return new Promise(resolve => {
      ApiService.post(`${baseURL}/SaveVisitForm`, payload).result.then(
        ({ data }) => {
          resolve(data);
        }
      );
    });
  },
  getOneVisitForm(visitId) {
    return new Promise(resolve => {
      ApiService.get(`${baseURL}/GetOneVisitForm`, `?visitID=${visitId}`).then(
        ({ data }) => {
          resolve(data);
        }
      );
    });
  },
  deleteVisitForm(visitId) {
    return new Promise(resolve => {
      ApiService.delete(`${baseURL}/DeleteVisitForm?visitID=${visitId}`).then(
        ({ data }) => {
          resolve(data);
        }
      );
    });
  }
};
